<template>
  <div
    class="flex gap-2 flex-shrink-0"
  >
    <div
      v-for="(layer, index) in dataSources"
      :key="layer.id"
      :title="layer.label"
      class="flex flex-col justify-between items-start gap-2"
      :class="{
      'w-24 bg-gray-200 p-4 rounded-md': size === 'lg',
      'bg-gray-200 p-1 rounded-md': size === 'sm',
    }"
    >
      <label
        v-if="size === 'lg'"
        for=""
        class="w-full text-xs flex justify-between"
      >
        {{ layer.label }}
      </label>
      <div
        class="whitespace-nowrap flex justify-between items-center gap-2"
        :class="{
          'text-3xl': size === 'lg',
          'text-xs': size === 'sm',
        }"
      >
        {{ ratingsAnimated[index] }}
        <span class="text-sm">
          %
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThemeScore',
  props: {
    size: {
      type: String,
      default: 'lg',
    },
    dataSources: {
      type: Array,
      default: () => [{ id: 'action-ratings-sum', label: 'Action Ratings Sum' }, { id: 'user-ratings', label: 'User Ratings' }],
    },
    datasets: {
      type: Array,
      default: () => [0, 0],
    },
  },
  data () {
    return {
      ratingsAnimated: this.datasets,
    }
  },
  watch: {
    dataSources: {
      deep: true,
      immediate: true,
      handler (newValue) {
        this.updateCategoryRating(newValue)
      },
    },
    datasets: {
      deep: true,
      immediate: true,
      handler (newValue) {
        this.updateCategoryRating(this.dataSources)
      },
    },
  },
  methods: {
    updateCategoryRating (layers) {
      layers.forEach((_, index) => {
        this.counter(this.datasets[index], index)
      })
    },
    async counter (newValue, index) {
      const delay = 5
      const sleep = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms))
      }
      if (newValue > this.ratingsAnimated[index]) {
        for (let i = this.ratingsAnimated[index]; i <= newValue; i++) {
          if (i >= newValue - 10) await sleep(delay * 3)
          if (i >= newValue - 20) await sleep(delay * 2)
          else await sleep(delay)
          this.ratingsAnimated[index] = i
        }
      }
      if (newValue < this.ratingsAnimated[index]) {
        for (let i = this.ratingsAnimated[index]; i >= newValue; i--) {
          if (i <= newValue + 10) await sleep(delay * 3)
          if (i <= newValue + 20) await sleep(delay * 2)
          else await sleep(delay)
          this.ratingsAnimated[index] = i
        }
      }
    },
  },
}
</script>

<style>

</style>
